import { CarDataLadderSearchService } from '../../../epics/fields/autoData';
import {
    getCarBodyTypeKey,
    getCarGenerationKey,
    getCarMarkKey,
    getCarModelKey,
    getCarModificationKey,
    getCarTypeKey,
    getCarCharacteristicKey,
} from './carKeys';
import { createCachedServiceThunk } from '../../thunkFactory';

export const getCarType = createCachedServiceThunk(
    getCarTypeKey,
    () => CarDataLadderSearchService.getCarType(),
);

export const getCarMark = createCachedServiceThunk(
    getCarMarkKey,
    (type) => CarDataLadderSearchService.getCarMark(type),
);

export const getCarModel = createCachedServiceThunk(
    getCarModelKey,
    (mark) => CarDataLadderSearchService.getCarModel(mark),
);

export const getCarGeneration = createCachedServiceThunk(
    getCarGenerationKey,
    (params) => CarDataLadderSearchService.getCarGeneration(params),
);

export const getCarBodyType = createCachedServiceThunk(
    getCarBodyTypeKey,
    (params) => CarDataLadderSearchService.getCarBodyType(params),
);

export const getCarCharacteristic = createCachedServiceThunk(
    getCarCharacteristicKey,
    (params) => CarDataLadderSearchService.getCarCharacteristic(params),
);

export const getCarTechData = createCachedServiceThunk(
    'car/getCarTechData',
    (params) => CarDataLadderSearchService.getCarTechData(params),
);

export const getCarModification = createCachedServiceThunk(
    getCarModificationKey,
    (params) => CarDataLadderSearchService.getCarModification(params),
);
